import { getEnvironmentDisplayName } from "../../../../react/core/utils/getEnvironmentDisplayName";

/**
 *
 * @name app.infrastructure:EventBusRun
 * @date
 * @copyright 2015 Empower Retirement
 * @description
 *
 *      Makes the event bus available on the globalThis window object.
 *
 * - Amplitude API Keys -
 * PROD - "c165f6e95ef99c534bc070242a5aa219"
 * v2 DEV - "ca5490bfc27fecd4e3d6561e0d151018" (a.k.a TEST)
 * v1 Dev - "925748197cab9929e04b9551639c4c98" (deprecated)
 */

var EventBusRun = function (eventBus) {
    // add the event bus to the globalThis window object
    eventBus.addToGlobal();
};

// Create a reference for injected objects to protect against minification
EventBusRun.$inject = ["eventBus"];
export default EventBusRun;
